<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <b-form @submit.prevent="handleSubmit(submit)">
      <ValidationProvider
        name="name"
        rules="required|min:1"
        v-slot="{ dirty, validated, valid, errors }"
      >
        <b-form-group label="Name">
          <b-form-input
            v-model="model.name"
            placeholder="Enter a name"
            :state="dirty || validated ? valid : null"
            required
          />
          <b-form-invalid-feedback>
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </ValidationProvider>
      <b-form-group label="Description (Optional)">
        <b-form-textarea
          v-model="model.description"
          rows="3"
          max-rows="3"
          placeholder="Enter a description"
        />
      </b-form-group>
      <b-button variant="primary" type="submit">
        <b-spinner
          v-if="saving"
          variant="light"
          aria-label="Saving"
          style="height: 20px; width: 20px"
        ></b-spinner>
        <span v-else>Save</span>
      </b-button>
      <router-link tag="a" class="btn" :to="{ name: 'packages' }">
        Cancel
      </router-link>
    </b-form>
  </ValidationObserver>
</template>
<script>
import _ from 'lodash';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    package: {
      type: Object,
      default: () => ({
        name: null,
        description: null
      })
    },
    saving: Boolean
  },
  data() {
    return {
      model: {}
    };
  },
  methods: {
    submit() {
      this.$emit('submit', this.model);
    }
  },
  created() {
    this.model = _.cloneDeep(this.package);
  }
};
</script>
